/**
 * Converts a `Booleanish` value to `boolean` or `undefined`.
 *
 * Booleanish is used by react to type attributes like `aria-disabled`
 *
 * @internal
 * @see {@link https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react/index.d.ts#L27 | `Booleanish` from @types/react}
 */
export function parseBoolean(
  booleanish: boolean | 'true' | 'false' | undefined,
): boolean | undefined {
  if (booleanish === undefined) {
    return;
  }
  if (typeof booleanish === 'boolean') {
    return booleanish;
  }
  return booleanish === 'true';
}
